import React from "react";
import BaseSpread, { CardPosition } from "./BaseSpread";

// Generate position data for Horseshoe spread (7 cards)
// Cards are arranged in a U-shape from left to right
// Each position contains: left, top, width, height (all in percentages)
const generateHorseshoePositions = (spacing: number = 12): CardPosition[] => {
    const cardHeight = spacing * 1.726; // Maintain card aspect ratio (standard tarot card ratio)
    return [
        { left: 0, top: 55, width: spacing, height: cardHeight },                    // 0: Past influences (bottom left)
        { left: spacing * 1.2, top: 35, width: spacing, height: cardHeight },    // 1: Present situation (left side)
        { left: spacing * 2.2, top: 15, width: spacing, height: cardHeight },    // 2: Hidden influences (top left)
        { left: spacing * 3.8, top: 10, width: spacing, height: cardHeight },     // 3: Current situation (center top)
        { left: spacing * 5.4, top: 15, width: spacing, height: cardHeight },    // 4: Challenges/obstacles (top right)
        { left: spacing * 6.6, top: 35, width: spacing, height: cardHeight },    // 5: Possible outcome (right side)
        { left: spacing * 7.4, top: 55, width: spacing, height: cardHeight }     // 6: Final outcome (bottom right)
    ];
};

interface HorseshoeSpreadProps {
    size?: number;
    cardWidth: number;
    displaySpread: boolean;
    getCard: (index: number) => React.ReactNode;
    spacing?: number; // Spacing between cards (default: 10)
}

const HorseshoeSpread = ({ size, cardWidth, displaySpread, getCard, spacing = 10 }: HorseshoeSpreadProps) => {
    const positions = generateHorseshoePositions(spacing);

    return (
        <BaseSpread
            positions={positions}
            size={size}
            cardWidth={cardWidth}
            displaySpread={displaySpread}
            getCard={getCard}
            rotatedCards={[]} // No rotated cards in horseshoe spread
            name="horseshoe"
        />
    );
};

export default HorseshoeSpread; 